"use strict";

if (document.getElementById("js-consensys")) {
  new Vue({
    delimiters: ['[[', ']]'],
    el: '#js-consensys',
    data: {
      modalFormOpen: false
    },
    mounted: function mounted() {
      this.modalFormOpen = this.$refs.modalForm.classList.contains('has-error');
    },
    methods: {
      openModalForm: function openModalForm() {
        this.modalFormOpen = true;
      },
      closeModalForm: function closeModalForm() {
        this.modalFormOpen = false;
      }
    }
  });
}
/********
ANIMATION
*********/


$(function () {
  if ($('.consensys-to-draw').length) {
    $('.consensys-to-draw .js-letter').velocity({
      opacity: 0,
      translateY: 20
    }, 0);
    $('.consensys-to-draw .js-letter').delay(1100).each(function (i) {
      var that = $(this),
          delay = 80 * i;
      that.velocity({
        opacity: 1,
        translateY: 0
      }, {
        duration: 800,
        delay: delay,
        easing: [0.250, 0.250, 0, 1]
      });
    });
    $('.consensys-to-draw .js-logo').velocity({
      opacity: 0,
      rotateZ: "+=90",
      scale: 0.9
    }, 0);
    $('.consensys-to-draw .js-logo').delay(900).velocity({
      opacity: 1,
      rotateZ: "-=90",
      scale: 1
    }, {
      duration: 1600,
      easing: [0.250, 0.250, 0, 1]
    });
    $('.consensys-to-draw .js-branch').each(function (j) {
      var calques = $(this).find('.cls-1').get().reverse();
      $(calques).velocity({
        opacity: 0
      }, 0);
      $(calques).delay(1000).each(function (i) {
        var delay = 80 * i;
        $(this).velocity({
          opacity: 1
        }, {
          duration: 400,
          delay: delay,
          easing: [0.250, 0.250, 0, 1]
        });
      });
    });
  }
});